<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-building"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<div class="page-body">
  <div class="table-card">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-list"></i>
      </div>
      <span class="card-header-title">{{ texts.tabela_de_empresas }}</span>
    </div>

    <div class="card-content">
      <!-- Barra de busca + Seletor de colunas -->
      <div class="search-bar">
        <p-iconField iconPosition="right" class="search-field">
          <p-inputIcon styleClass="pi pi-search" />
          <input pInputText type="text"
            [placeholder]="placeholders.pesquisar"
            [(ngModel)]="filterName"
            (ngModelChange)="onSearchChange($event)" />
        </p-iconField>

        <app-column-selector
          [columns]="colunasEmpresas"
          [storageKey]="STORAGE_KEY_EMPRESAS"
          (columnsChange)="onColunasEmpresasChange($event)">
        </app-column-selector>
      </div>

      <!-- Tabela -->
      <p-table [value]="empresas" [loading]="loading"
        (onSort)="onSortEmpresas($any($event))"
        [sortField]="lastfield" [sortOrder]="lastSort === 'asc' ? 1 : -1"
        [tableStyle]="{ 'width': '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th [hidden]="!isColunaEmpresaVisivel('nome')" pSortableColumn="nome" style="width: 32%">
              {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
            </th>
            <th [hidden]="!isColunaEmpresaVisivel('ruc')" pSortableColumn="ruc" style="width: 18%">
              {{ labels.ruc }}<p-sortIcon [field]="'ruc'"></p-sortIcon>
            </th>
            <th [hidden]="!isColunaEmpresaVisivel('email')" pSortableColumn="email" style="width: 25%">
              {{ labels.email }}<p-sortIcon [field]="'email'"></p-sortIcon>
            </th>
            <th [hidden]="!isColunaEmpresaVisivel('telefone')" style="width: 17%">
              {{ labels.telefone }}
            </th>
            <th [hidden]="!isColunaEmpresaVisivel('acoes')" style="width: 8%">{{ labels.acoes }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-empresa>
          <tr class="empresa-row" (click)="abrirEmpresa(empresa)">
            <td [hidden]="!isColunaEmpresaVisivel('nome')">
              <span class="empresa-nome">{{ empresa.nome }}</span>
            </td>
            <td [hidden]="!isColunaEmpresaVisivel('ruc')">{{ empresa.ruc || '-' }}</td>
            <td [hidden]="!isColunaEmpresaVisivel('email')">{{ empresa.email || '-' }}</td>
            <td [hidden]="!isColunaEmpresaVisivel('telefone')">{{ (empresa | formatPhone) || '-' }}</td>
            <td [hidden]="!isColunaEmpresaVisivel('acoes')" class="actions" (click)="$event.stopPropagation()">
              <button pButton icon="pi pi-arrow-right"
                class="p-button-text p-button-rounded p-button-sm action-btn select-btn"
                [pTooltip]="tooltips.abrir" tooltipPosition="top"
                (click)="abrirEmpresa(empresa)">
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="colunasEmpresasVisiveis" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ texts.nenhuma_empresa }}</div>
                <div class="text-gray-400 text-sm mt-1">{{ texts.dica_busca }}</div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td [attr.colspan]="colunasEmpresasVisiveis" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ texts.carregando }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Paginacao -->
      <div class="pagination-container">
        <div>
          <p-paginator (onPageChange)="onPageChange($any($event))"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"
            [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
          <p-dropdown [options]="pageSizeOptions" optionLabel="label"
            optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>
